import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import { news } from "@/mocks/news";

export default function NewsPreview() {
  const preview = news.slice(0, 3);

  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <SectionTitle
        icon="ri-newspaper-line"
        title="最新影视资讯"
        description="行业动态、影片预告与影视新闻，第一时间了解"
        moreHref="/news"
        moreLabel="更多资讯"
      />
      <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
        {preview.map((item) => (
          <Link
            key={item.id}
            to={`/news/detail/${item.id}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-300"
          >
            <div className="relative h-44 w-full overflow-hidden bg-background-200">
              <img
                src={item.cover}
                alt={`${item.title} 配图`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-md bg-primary-950/70 px-2 py-1 text-xs font-medium text-background-50">
                {item.category}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <h3 className="line-clamp-2 text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-accent-600">
                {item.title}
              </h3>
              <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
                {item.summary}
              </p>
              <div className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-time-line"></i>
                {item.publishDate}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}